import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { api, useApi } from "../api";
import { PageShell } from "../components/Layout";
import { Reveal, Marquee } from "../components/Motion";
import Seo from "../components/Seo";
import { PageHero, Loading } from "../components/Sections";

export default function Locations() {
  const { data, loading } = useApi(api.cities, []);

  return (
    <PageShell>
      {loading || !data ? (
        <Loading />
      ) : (
        <>
          <Seo
            title="Security Guard Coverage by UK City | Xtreme Protection"
            description="Explore security guard, patrol and event coverage by UK city. Find a location page and discuss the right service for your property or event."
            keywords="security guards London, security guards Birmingham, mobile patrol Manchester, security guards Glasgow, event security Bristol"
            path="/locations"
          />
          <PageHero
            eyebrow="THE TERRITORY // 4 NATIONS // 12 REGIONS"
            lines={["SECURITY GUARD", "COVERAGE ACROSS UK", "TOWNS AND CITIES"]}
            intro={[
              "Choose your region to see local service options and speak to the team about site requirements and availability.",
              `Xtreme Protection delivers SIA-licensed security guard services in more than ${data.regions.reduce((a, r) => a + r.count, 0)} towns and cities across England, Scotland, Wales and Northern Ireland. Select your location to explore manned guarding, mobile patrols, CCTV monitoring, door supervision, event security, key holding and every other specialist service available in your area.`,
            ]}
            breadcrumb={[{ label: "Home", path: "/" }, { label: "Locations", path: "/locations" }]}
          />
          <Marquee items={data.services.map((s) => s.name)} />
          <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 space-y-14" data-testid="locations-index">
            {data.regions.map((g) => (
              <Reveal key={g.region}>
                <section data-testid={`region-${g.region.toLowerCase().replace(/\s+/g, "-")}`}>
                  <div className="flex items-baseline gap-4 mb-6 border-b border-white/10 pb-4">
                    <Link
                      to={`/regions/${g.region.toLowerCase().replace(/\s+/g, "-")}`}
                      data-testid={`region-hub-link-${g.region.toLowerCase().replace(/\s+/g, "-")}`}
                      className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-white hover:text-amber transition-colors"
                    >
                      Security Services in {g.region}
                    </Link>
                    <span className="font-mono text-xs text-amber tracking-widest">{g.count} LOCATIONS</span>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5">
                    {g.cities.map((c) => (
                      <Link
                        key={c.slug}
                        to={`/locations/${c.slug}`}
                        data-testid={`location-link-${c.slug}`}
                        className="group flex items-center gap-2.5 border border-white/10 bg-card px-4 py-3 hover:border-amber transition-colors duration-300"
                      >
                        <MapPin className="w-3.5 h-3.5 text-amber shrink-0" />
                        <span className="min-w-0">
                          <span className="block font-display font-bold uppercase tracking-wide text-sm text-white group-hover:text-amber transition-colors truncate">
                            {c.name}
                          </span>
                          <span className="block font-mono text-[9px] uppercase tracking-widest text-gray-500 truncate">{c.county}</span>
                        </span>
                      </Link>
                    ))}
                  </div>
                </section>
              </Reveal>
            ))}
          </div>
        </>
      )}
    </PageShell>
  );
}
